import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ErrorMessage, Field } from "formik";

import {
  setApartmentData,
  selectContactArea,
  setContactMeData
} from "../../reducers/apartmentAction";

class OtherInformationCard extends Component {
  selectContactArea(area) {
    this.props.selectContactArea(area);
    this.props.setFieldValue("selectedContactMeArea", area);
  }

  setContactMe(bool) {
    this.props.setContactMeData({ bool });
    this.props.setFieldValue("contactMe", bool);
  }

  render() {

    const wantToBeContactedFields = this.props.customerSection ? (<div className="col-md-6">
    <div className="row">
      <div className="col-md-12">
        <div className="form-group">
          <label>&nbsp;</label>
          <div className="custom-control custom-checkbox mr-1">
            <input
              type="checkbox"
              className="custom-control-input"
              onChange={() => this.setContactMe(!this.contactMe) }
              id="checkboxContactMe"
              checked={this.contactMe}
            />
            <label className="custom-control-label" htmlFor="checkboxContactMe" >
              Kontakta mig för mer information om
            </label>
            <Field name="contactMe" type="hidden" className="form-control" />
          </div>
        </div>
      </div>

      <div className="col-md-12">
        <div className="form-group">
          <div className="dropdown" id="custom-select" tabIndex="0">
            <div type="text" className="custom-select-dd" id="selectContactArea" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
              <span>
                {this.props.values.selectedContactMeArea ? this.props.values.selectedContactMeArea.name : "Välj område"}
              </span>
            </div>

            <div className="dropdown-menu custom-dropdown" aria-labelledby="selectContactArea" >
              {this.props.contactMeArea.map(area => (
                <div className="dropdown-item" onClick={() => this.selectContactArea(area)} key={area.id} >
                  {area.name}
                </div>
              ))}
            </div>
          </div>
        </div>

        <Field name="selectedContactMeArea" type="hidden" className={ "form-control" + (this.props.errors.selectedContactMeArea && this.props.touched.selectedContactMeArea ? " is-invalid" : "") } />
        <ErrorMessage name="selectedContactMeArea" component="div" className="invalid-feedback" />
      </div>
      
      <div className="col-md-12">
        <div className="form-group">
          <label htmlFor="basic-addon2"> Jag vill ha information om </label>
          <div className="input-group">
            <Field
              name="wantInformationOn"
              type="textArea"
              rows="4"
              component="textarea"
              onBlur={e => {
                // call the built-in handleBur
                this.props.handleBlur(e);
                this.props.setApartmentData({ want_information_on: e.target.value });
              }}
              className={"form-control"}
            />
          </div>
        </div>
      </div>

    </div>
  </div>) : "";

    return (
      <div>
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Övrig information</label>
                  <div className="input-group">
                    <Field
                      name="otherInformation"
                      type="textArea"
                      rows="9"
                      component="textarea"
                      onBlur={e => {
                        // call the built-in handleBur
                        this.props.handleBlur(e);
                        this.props.setApartmentData({ other_information: e.target.value });
                      }}
                      className={"form-control"}
                    />
                  </div>
                </div>
              </div>
              
              { wantToBeContactedFields }
              
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    otherInformation: state.apartmentReducer.apartment_information.other_information,
    contactMe: state.apartmentReducer.apartment_information.contact_me,

    wantInformationOn: state.apartmentReducer.apartment_information.want_information_on,

    selectedContactMeArea: state.apartmentReducer.apartment_information.selected_contact_me_area,
    contactMeArea: state.apartmentReducer.apartment_information.contact_me_area,

    customerSection: state.simpleReducer.customerSection
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setApartmentData: bindActionCreators(setApartmentData, dispatch),
    selectContactArea: bindActionCreators(selectContactArea, dispatch),
    setContactMeData: bindActionCreators(setContactMeData, dispatch)
  };
};

export default connect( mapStateToProps, mapDispatchToProps )(OtherInformationCard);